import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withApollo } from '@apollo/react-hoc';
import { gsap } from 'gsap/dist/gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
import { commonMapDispatchToProps, commonMapStateToProps } from '../../../utils/Helpers/AppHelper';

if (typeof window !== `undefined`) {
	gsap.registerPlugin(ScrollTrigger);
	gsap.core.globals('ScrollTrigger', ScrollTrigger);
}

class UIScrollTrigger extends Component {
	constructor(props) {
		super(props);

		this.state = {};
	}

	// Mark: Lifecycle functions
	componentDidMount() {
		let { triggerId, scroller, targetId } = this.props;
		const triggerElement = document.querySelector(`#${triggerId}`);
		const scrollerElement = document.querySelector(scroller);
		const targetElement = targetId ? document.querySelector(`#${targetId}`) : triggerElement;
		if (triggerElement && scrollerElement) {
			setTimeout(() => this.setScrollTrigger(triggerElement, targetElement, scrollerElement), 100);
		}
	}

	//Mark: Component functions
	setScrollTrigger = (triggerElement, targetElement, scrollerElement) => {
		let { triggerId, start, end, once, markers, horizontal, tweenFromProps, tweenToProps, pin, pinSpacing, pinReparent, endTrigger } = this.props;

		gsap.fromTo(targetElement, tweenFromProps, {
			scrollTrigger: {
				id: `id:${triggerId}`,
				trigger: triggerElement,
				endTrigger: endTrigger ? `#${endTrigger}` : triggerElement,
				scroller: scrollerElement,
				start,
				pin,
				end,
				horizontal,
				markers,
				once,
				anticipatePin: 1,
				pinSpacing,
				pinReparent,
				scrub: true
			},
			...tweenToProps
		});

		ScrollTrigger.refresh();
		ScrollTrigger.update();
	};

	//Mark: Render functions
	render() {
		const { triggerId, style, className } = this.props;
		return (
			<div key={triggerId} id={triggerId} style={style} className={className}>
				{this.props.children}
			</div>
		);
	}
}

export default withApollo(connect(commonMapStateToProps, commonMapDispatchToProps)(UIScrollTrigger));
